import script from "./item8.vue?vue&type=script&setup=true&lang=js"
export * from "./item8.vue?vue&type=script&setup=true&lang=js"

import "./item8.vue?vue&type=style&index=0&id=bb47a134&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb47a134"]])

export default __exports__